import { Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { WhiteboardSaveState } from '../whiteboardSaver'

interface Props {
  state: WhiteboardSaveState
}

const color: Record<WhiteboardSaveState, string> = {
  idle: 'gray.500',
  pending: 'gray.500',
  saving: 'gray.500',
  saved: 'green.500',
  error: 'red.500',
}

// Always tells where the saving of the whiteboard stands (#200)
export default function WhiteboardSaveStatus({ state }: Props) {
  const { t } = useTranslation()
  if (state === 'idle') return null
  return (
    <Text fontSize="sm" color={color[state]} role="status" aria-live="polite">
      {t(`WhiteboardSaveStatus.${state}`)}
    </Text>
  )
}
